import { styled } from '@mui/material';

import { useThemeColor } from '../../../hooks/theme';
import { WithRef } from '../../../types';
import { mapPaletteColorToDataColorToken } from '../../../utils/mapPaletteColorToDataColorToken';

export type ChartIndicatorProps = {
  variant: 'filled' | 'outlined';
  size: 'large' | 'small';
  color: string;
};

const StyledChartIndicator = styled('div', {
  name: 'DsChartIndicator',
  slot: 'Root',
  target: 'DsChartIndicator-root',
  shouldForwardProp: (propName) =>
    propName !== 'size' && propName !== 'color' && propName !== 'variant',
  overridesResolver: (props, styles) => [
    styles.root,
    styles[props.size],
    props.variant === 'filled'
      ? {
          backgroundColor: props.color,
        }
      : {
          border: `2px solid ${props.color}`,
        },
  ],
})<ChartIndicatorProps>({});

export const ChartIndicator = ({
  ref,
  ...props
}: WithRef<HTMLDivElement, ChartIndicatorProps>) => {
  const themedColor = useThemeColor(
    mapPaletteColorToDataColorToken(props.color, props.color)
  );
  return <StyledChartIndicator {...props} color={themedColor} ref={ref} />;
};

ChartIndicator.displayName = 'ChartIndicator';
